import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { showError, showSessionExpired } from "../../helpers/Toast";

import "moment/locale/id";

import moment from "moment";
import { Helmet } from "react-helmet";
import { ShimmerTitle } from "react-shimmer-effects";

import {
  IconPresensiMasukPutih,
  IconPresensiPulangPutih,
  ImageBg,
} from "../../assets";
import { Buttons, Footer } from "../../components";
import { useAuth } from "../../context/AuthContext";
import { biodataUrl, dashboardUrl } from "../../helpers/ApiPresensi";
import { decryptLocalStorage } from "../../helpers/SecureStorage";
import { colors } from "../../utils";

const statusColor = {
  TEPAT: { bg: "#D1FAE5", text: "#065F46" },
  TELAT: { bg: "#FEE2E2", text: "#991B1B" },
  IZIN: { bg: "#FEF3C7", text: "#92400E" },
  DEFAULT: { bg: "#E0F2FE", text: "#0369A1" },
};

const Home = () => {
  const [date] = useState(new Date());
  const [biodata, setbiodata] = useState([]);
  const [aktivitasList, setAktivitasList] = useState([]);

  const navigate = useNavigate();
  const { logout, handleSessionExpired } = useAuth();
  const [ringkasan, setringkasan] = useState([]);
  const [messagejadwal, setmessagejadwal] = useState("");
  const [jumlahShift, setJumlahShift] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [bulanRingkasan, setBulanRingkasan] = useState("");
  const [shift, setshift] = useState([]);

  const token = decryptLocalStorage(process.env.REACT_APP_LOCAL_STORAGE_TOKEN);

  const getdashboard = async () => {
    try {
      setIsLoading(true);

      const response = await fetch(dashboardUrl, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status !== 200) {
        if (response.status === 401) {
          handleSessionExpired();
          await showSessionExpired();
          navigate("/");
          return;
        }
        const data = await response.json();
        showError(data.message || "Terjadi kesalahan");
        return;
      }

      const data = await response.json();

      if (data.data.aktivitas) {
        setAktivitasList(data.data.aktivitas);
      }

      if (data.data.shift) {
        setJumlahShift(data.data.shift.length);
        setshift(data.data.shift);
      }

      setringkasan(data.data.ringkasan);
      setmessagejadwal(data.data.message);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const getbio = async () => {
    try {
      setIsLoading(true);

      const response = await fetch(biodataUrl, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status !== 200) {
        if (response.status === 401) {
          handleSessionExpired();
          await showSessionExpired();
          navigate("/");
          return;
        }
        const data = await response.json();
        showError(data.message || "Terjadi kesalahan");
        return;
      }

      const data = await response.json();
      setbiodata(data.data);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const gotopresensi = (tipe) => {
    navigate("/presensi", { state: tipe });
  };

  const gotouploaddinas = () => {
    navigate("/upload-dinas", { state: { shift } });
  };

  useEffect(() => {
    getbio();
    getdashboard();
  }, []);

  useEffect(() => {
    if (ringkasan?.bulan && ringkasan?.tahun) {
      const sekarang = moment(`${ringkasan.bulan}-${ringkasan.tahun}`, "MM-YYYY");
      setBulanRingkasan(sekarang.format("MMMM YYYY"));
    }
  }, [ringkasan]);

  const ringkasanItems = [
    { label: "Tepat", value: ringkasan?.jumlah_tepat, color: "#D1FAE5", textColor: "#065F46" },
    { label: "Telat", value: ringkasan?.jumlah_telat, color: "#FEE2E2", textColor: "#991B1B" },
    { label: "Izin", value: ringkasan?.jumlah_izin, color: "#FEF3C7", textColor: "#92400E" },
    { label: "Dinas", value: ringkasan?.jumlah_dl, color: "#DBEAFE", textColor: "#1E40AF" },
    { label: "Alpa", value: ringkasan?.jumlah_tanpa_keterangan, color: "#FEE2E2", textColor: "#991B1B" },
  ];

  return (
    <div className="flex flex-col min-h-screen overflow-x-hidden bg-gray-50">
      <Helmet>
        <title>Beranda — Presensi</title>
      </Helmet>

      <div className="flex-grow">
        {/* Header */}
        <div
          className="relative py-6 px-5"
          style={{
            background: "linear-gradient(135deg, #FFB703 0%, #e6a200 100%)",
            minHeight: 120,
          }}
        >
          <div className="flex items-center justify-between">
            <div className="flex-1 min-w-0 pr-4">
              {isLoading ? (
                <div className="space-y-2">
                  <div className="h-5 w-36 bg-white/30 rounded-lg animate-pulse" />
                  <div className="h-4 w-24 bg-white/20 rounded-lg animate-pulse" />
                </div>
              ) : (
                <>
                  <p className="text-white/80 text-xs font-medium mb-0.5">Selamat datang,</p>
                  <h2 className="text-white text-lg font-bold leading-snug truncate">
                    {biodata?.nama_pegawai || "—"}
                  </h2>
                  <span className="inline-block mt-1 text-xs font-medium text-yellow-900 bg-white/30 rounded-full px-2.5 py-0.5">
                    {biodata?.jenis_pegawai || ""}
                  </span>
                </>
              )}
            </div>

            <div className="shrink-0">
              {isLoading ? (
                <div className="w-14 h-14 rounded-full bg-white/30 animate-pulse" />
              ) : (
                <img
                  alt={biodata?.nama_pegawai}
                  src={
                    biodata?.foto === false
                      ? `https://ui-avatars.com/api/?background=e6a200&color=fff&name=${encodeURIComponent(biodata?.nama_pegawai || "U")}`
                      : biodata?.foto
                  }
                  className="w-14 h-14 rounded-full object-cover border-2 border-white shadow-md"
                />
              )}
            </div>
          </div>

          {/* Wave decoration */}
          <div className="absolute bottom-0 left-0 right-0 overflow-hidden leading-none">
            <svg viewBox="0 0 400 20" preserveAspectRatio="none" className="w-full h-5 fill-gray-50">
              <path d="M0,10 C100,20 300,0 400,10 L400,20 L0,20 Z" />
            </svg>
          </div>
        </div>

        <div className="px-4 pb-4 space-y-4" style={{ marginTop: -2 }}>
          {/* Presensi Card */}
          {isLoading ? (
            <div className="bg-white rounded-2xl shadow-sm p-4 border border-gray-100">
              <ShimmerTitle line={2} gap={10} variant="primary" />
            </div>
          ) : (
            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
              <div className="flex items-center justify-between px-4 pt-4 pb-2">
                <div className="flex items-center gap-1.5 text-gray-500">
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                  <span className="text-xs font-medium">{moment(date).format("dddd, DD MMMM YYYY")}</span>
                </div>
                <span className="text-xs font-semibold rounded-full px-2.5 py-0.5" style={{ color: "#e6a200", backgroundColor: "#FFF3CD" }}>
                  {jumlahShift} Shift
                </span>
              </div>

              <div className="px-4 pb-4 flex gap-3 mt-2">
                <button
                  onClick={() => gotopresensi("masuk")}
                  className="flex-1 flex items-center justify-center gap-2 rounded-xl py-3 text-sm font-semibold text-white shadow-sm transition active:scale-95"
                  style={{ background: "linear-gradient(135deg, #FFB703 0%, #f5a800 100%)" }}
                >
                  <img src={IconPresensiMasukPutih} alt="" className="w-4 h-4" />
                  Presensi Masuk
                </button>
                <button
                  onClick={() => gotopresensi("pulang")}
                  className="flex-1 flex items-center justify-center gap-2 rounded-xl py-3 text-sm font-semibold text-white shadow-sm transition active:scale-95"
                  style={{ background: "linear-gradient(135deg, #e6a200 0%, #cc8f00 100%)" }}
                >
                  <img src={IconPresensiPulangPutih} alt="" className="w-4 h-4" />
                  Presensi Pulang
                </button>
              </div>

              {messagejadwal ? (
                <div className="mx-4 mb-4 text-center text-xs text-gray-500 bg-gray-50 rounded-xl py-2 px-3">
                  {messagejadwal}
                </div>
              ) : null}
            </div>
          )}

          {/* Ringkasan */}
          <div>
            <div className="flex items-center justify-between mb-2 px-1">
              <h5 className="text-sm font-bold text-gray-700">Ringkasan</h5>
              <span className="text-xs text-gray-400">
                {isLoading ? "..." : bulanRingkasan}
              </span>
            </div>

            {isLoading ? (
              <div className="bg-white rounded-2xl shadow-sm p-4 border border-gray-100">
                <ShimmerTitle line={1} gap={10} variant="primary" />
              </div>
            ) : (
              <div className="grid grid-cols-5 gap-2">
                {ringkasanItems.map((item) => (
                  <div
                    key={item.label}
                    className="flex flex-col items-center justify-center rounded-xl py-3 shadow-sm"
                    style={{ backgroundColor: item.color }}
                  >
                    <span className="text-base font-bold" style={{ color: item.textColor }}>
                      {item.value ?? 0}
                    </span>
                    <span className="text-xs font-medium mt-0.5" style={{ color: item.textColor }}>
                      {item.label}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Menu */}
          <div>
            <h5 className="text-sm font-bold text-gray-700 mb-2 px-1">Menu</h5>
            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 px-2 py-3">
              <div className="grid grid-cols-4 gap-x-1 gap-y-2">
                <Link to="/jadwal" className="block">
                  <Buttons menu icontype="presensi" text="Jadwal" />
                </Link>
                <Link to="/riwayat-presensi" className="block">
                  <Buttons menu icontype="riwayat" text="Riwayat Presensi" />
                </Link>
                <Link to="/rekap-presensi" className="block">
                  <Buttons menu icontype="reporting" text="Rekap Presensi" />
                </Link>
                <Link to="/izin" className="block">
                  <Buttons menu icontype="izin" text="Izin" />
                </Link>
                <div className="block" onClick={gotouploaddinas}>
                  <Buttons menu icontype="dinas" text="Dinas" />
                </div>
                <Link to="/riwayat-dinas" className="block">
                  <Buttons menu icontype="profile" text="Riwayat Dinas" />
                </Link>
                <Link to="/riwayat-izin" className="block">
                  <Buttons menu icontype="historyizin" text="Riwayat Izin" />
                </Link>
                <div className="block">
                  <Buttons menu icontype="help" text="Bantuan" />
                </div>
              </div>
            </div>
          </div>

          {/* Aktivitas */}
          <div>
            <h5 className="text-sm font-bold text-gray-700 mb-2 px-1">Aktivitas Terkini</h5>

            {isLoading ? (
              <div className="bg-white rounded-2xl shadow-sm p-4 border border-gray-100">
                <ShimmerTitle line={3} gap={10} variant="primary" />
              </div>
            ) : aktivitasList.length > 0 ? (
              <div className="space-y-2">
                {aktivitasList.map((item, index) => {
                  const [hours, minutes] = item.jam.split(":");
                  const [year, month, day] = item.tgl.split("-");
                  const isMasuk = item.jenis_kehadiran === "MASUK";

                  const statusStyle = statusColor[item.status_kehadiran] || statusColor.DEFAULT;

                  return (
                    <div
                      key={index}
                      className="bg-white rounded-2xl shadow-sm border border-gray-100 px-4 py-3 flex items-center justify-between"
                    >
                      <div className="flex items-center gap-3">
                        <div
                          className="w-9 h-9 rounded-full flex items-center justify-center shrink-0"
                          style={{ backgroundColor: isMasuk ? "#D1FAE5" : "#FEE2E2" }}
                        >
                          <img
                            src={isMasuk ? IconPresensiMasukPutih : IconPresensiPulangPutih}
                            alt=""
                            className="w-4 h-4"
                            style={{ filter: isMasuk ? "invert(28%) sepia(87%) saturate(500%) hue-rotate(102deg)" : "invert(20%) sepia(96%) saturate(600%) hue-rotate(340deg)" }}
                          />
                        </div>
                        <div>
                          <p className="text-sm font-semibold text-gray-800">
                            Presensi {isMasuk ? "Masuk" : "Pulang"}
                          </p>
                          <p className="text-xs text-gray-400">{`${day}-${month}-${year}`}</p>
                        </div>
                      </div>

                      <div className="text-right">
                        <p className="text-sm font-bold text-gray-800">{`${hours}:${minutes}`}</p>
                        <span
                          className="text-xs font-semibold rounded-full px-2 py-0.5"
                          style={{ backgroundColor: statusStyle.bg, color: statusStyle.text }}
                        >
                          {item.status_kehadiran}
                        </span>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="bg-white rounded-2xl shadow-sm border border-gray-100 px-4 py-8 text-center text-sm text-gray-400">
                <svg className="w-10 h-10 mx-auto mb-2 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                </svg>
                Belum ada aktivitas hari ini
              </div>
            )}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Home;
